import { createFileRoute } from '@tanstack/react-router';
import { SecurityPolicyEditor } from '../../components/tenant/SecurityPolicyEditor';

export const Route = createFileRoute('/_authenticated/_layout/tenant/security')({
    component: () => (
        <div className="space-y-4">
            <p className="text-sm text-muted-foreground">
                Configura los métodos de verificación en dos pasos (MFA) que pueden usar los
                usuarios de tu tenant.
            </p>
            <SecurityPolicyEditor />
        </div>
    ),
});
